"use strict";

import $ from "jquery";
import constrainDivScroll from "./util/constrain_div_scroll";
import config from "./config";
import fixedInterval from "./util/fixed_interval";

const COMPACT_HEADER_SCROLL_OFFSET = 500;

const footerOffsetFromBottomOfWindow = function () {
  let offsetTop = 0;
  const $footer = $("footer.main-footer");
  if ($footer.length && $footer[0].getBoundingClientRect) {
    const offset = $footer[0].getBoundingClientRect();
    if (offset && offset.top) {
      offsetTop = offset.top;
    }
  }

  return $(window).height() - offsetTop;
};

// Make header smaller when scrolled down the page
const updateCompactHeader = function () {
  const $header = $("header.main-header");
  const scrollTop = $(window).scrollTop();
  if (scrollTop > COMPACT_HEADER_SCROLL_OFFSET && !$header.hasClass("compact")) {
    $header.addClass("compact");
  } else if (scrollTop <= COMPACT_HEADER_SCROLL_OFFSET && $header.hasClass("compact")){
    $header.removeClass("compact");
  }
};

const updateFooterPosition = function () {
  const footer = $("footer.main-footer");
  const mainContainer = $("#main-container");
  const body = $("body");

  if ($(window).height() > mainContainer.height() + $("header.main-header").height()) {
    body.addClass("sticky-footer");
    mainContainer.css({ paddingBottom: footer.height() });
  } else {
    body.removeClass("sticky-footer");
    mainContainer.css({ paddingBottom: 30 });
  }
};

const updateStickySize = function () {
  let bottom = footerOffsetFromBottomOfWindow();

  if (bottom < 0) {
    bottom = 0;
  }
  $("#left-sidebar, #right-sidebar").css({
    top: $("header.main-header").height(),
    bottom: bottom
  });
};

const updateMainTopMargin = function () {
  const header = $("header.main-header");
  if (header.length < 0) return;

  let marginTop = header.height() - 1;
  if ($(window).width() < config.flexboxgridBreakpoints.md) {
    marginTop = 0;
  }
  $("main").css({
    marginTop: marginTop
  });
};

// Just update everything when something changes
const updateEverything = function () {
  updateFooterPosition();
  updateMainTopMargin();
  updateStickySize();
};

// Clicking a sidebar link doesn't fix header height
const relativeLinkClicked = function () {
  setTimeout(() => updateEverything(), 0);
};

// Turbolinks retains the window between pages
$(window).on("scroll resize draw.dt turbolinks:load", updateEverything);
$(window).on("scroll resize", updateCompactHeader);
$(document).on("DOMContentLoaded", function () {
  window.setTimeout(updateStickySize, 0);
});

const adjustAnchorMargins = function () {
  const mainHeader = $("header.main-header");
  // Make sure that relative anchors respect the sticky header
  const anchorHeight = mainHeader.height() + 15;
  $("a.anchor").css({
    display: "block",
    position: "relative",
    zIndex: "-100",
    marginTop: `-${anchorHeight}px`,
    height: `${anchorHeight}px`
  });
  $("a.tinymce-anchor").css({
    display: "inline-block",
    zIndex: "-100",
    marginTop: `-${anchorHeight}px`,
    height: `${anchorHeight}px`,
    width: "0"

  });
  $("a[href^='#']").on("click", relativeLinkClicked);
};

$(document).on("turbolinks:load", function() {
  const sidebars = $("#left-sidebar, #right-sidebar");

  if (sidebars.length > 0) {
    $("#left-sidebar, #right-sidebar").each(function (i, e) {
      constrainDivScroll($(e));
    });
    updateStickySize();
  }

  // This is dreadful
  updateEverything();
  fixedInterval(updateEverything, 25, 10);
  $("#main-container").on("filtered.wd", updateStickySize);
  adjustAnchorMargins();
});

$(window).on("resize", adjustAnchorMargins);
